import { BaseGroup } from 'db-tables'

export const isFutureGroup = (group: BaseGroup) =>
  group.start_time && new Date(group.start_time).valueOf() > new Date().valueOf()

export const groupSelect =
  '*, tags:group_tags(tag:tag_id(id, name)), owner:owner_id(permissions(unlisted_participants_count,emotions_per_submission_count,can_use_custom_background,can_use_journal,can_use_widget))'
